import React from 'react';

/**
 * FormLabel - Atomic component for form field labels
 * @param {Object} props
 * @param {string} props.htmlFor - ID of the input element
 * @param {boolean} props.required - Whether the field is required
 * @param {string} props.className - Additional CSS classes
 * @param {React.ReactNode} props.children - Label text
 */
export const FormLabel = ({ htmlFor, required = false, className = '', children }) => {
    return (
        <label
            htmlFor={htmlFor}
            className={`block text-sm text-neutral-green-800 text-left py-1 ${className}`}
        >
            {required && <span className="text-red-500 font-bold">* </span>}
            {children}
        </label>
    );
};

export default FormLabel;
